import React from 'react';
import './ControlPanel.scss';

const DEFAULT_OPTIONS = [10, 50, 100, 500, 1000];

const ControlPanel = ({onChange, options = DEFAULT_OPTIONS, value}) => {
    return (
        <form className='control_panel--page-size' onChange={onChange}>
            {options.map((option, index) => {
                const stringValue = String(option);
                const inputProps = value === undefined
                    ? { defaultChecked: index === 0 }
                    : { checked: String(value) === stringValue, readOnly: true };

                return (
                    <div className='radio-wrapper' key={stringValue}>
                        <input
                            type="radio"
                            id={`records-${stringValue}`}
                            name="records-per-page"
                            value={stringValue}
                            {...inputProps}
                        />
                        <label htmlFor={`records-${stringValue}`}>{stringValue}</label>
                    </div>
                );
            })}
        </form>
    );
};

export default ControlPanel;
